module.exports = __webpack_public_path__ + "img/gls.7fbda919.jpg";